module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Italic.4d4d2e1.woff";